import { render, staticRenderFns } from "./patientDetails.vue?vue&type=template&id=5bc0c5d2&scoped=true&"
import script from "./patientDetails.vue?vue&type=script&lang=js&"
export * from "./patientDetails.vue?vue&type=script&lang=js&"
import style0 from "./patientDetails.vue?vue&type=style&index=0&id=5bc0c5d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc0c5d2",
  null
  
)

export default component.exports